import { Box, Inline, Text } from 'braid-design-system';

import * as styles from './NudgePill.css';

interface NudgePillProps {
  label: string;
  count: number;
  isActive: boolean;
  index: number;
  isMobile: boolean;
  onClick: (index: number) => void;
}

export const NudgePill = ({
  label,
  count,
  isActive,
  index,
  isMobile,
  onClick,
}: NudgePillProps) => (
  <Box
    data-automation="displayPills"
    key={index}
    role="button"
    onClick={() => onClick(index)}
    borderRadius="full"
    paddingRight="xxsmall"
    paddingLeft="small"
    paddingY="xxsmall"
    cursor="pointer"
    className={`${styles.nudgePill} ${
      isActive ? styles.selectedNudgePill : styles.nudgePill
    }`}
    background={isActive ? 'customDark' : 'customLight'}
  >
    <Inline space="xxsmall" alignY="center">
      <Text size={isMobile ? 'small' : 'standard'} baseline={false}>
        {label}
      </Text>
      <Box
        display="inline"
        background="positiveLight"
        paddingY="xxsmall"
        paddingX="xsmall"
        borderRadius="large"
      >
        <Text tone="positive" size="xsmall" weight="medium">
          {count > 99 ? '99+' : count}
        </Text>
      </Box>
    </Inline>
  </Box>
);
